// extracted by mini-css-extract-plugin
module.exports = {"stars":"stars_stars__jHB6z","active":"stars_active__xvpHu"};